import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';
import { Button, Container, Typography } from '@mui/material';
import { Link } from 'react-router-dom';

/**
 * A section on the about page that encourages our user to take action.
 */
const Action = () => (
  <Container
    maxWidth="md"
    sx={{
      paddingY: '3em',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
    }}
  >
    <Typography variant="h4" component="h2" gutterBottom>
      Ready to Protect Your Team?
    </Typography>
    <Typography variant="h6" component="p" textAlign="center">
      Get immediate access to our life-saving training and empower your
      organization to respond confidently during critical moments.
    </Typography>
    <Button
      component={Link}
      to="/purchase-training"
      variant="contained"
      color="primary"
      size="large"
      endIcon={<ChevronRightRoundedIcon />}
      sx={{
        marginY: '3em',
      }}
    >
      Start Training Now
    </Button>
  </Container>
);

export default Action;
